import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { contact } from '../data/site';
export function UtilityBar() {
  return <div className="bg-ink text-paper" data-id="element-236" data-mp="22kairqytoy4g">
      <div className="mx-auto flex h-10 max-w-[1320px] items-center justify-between gap-4 px-5 text-[11px] font-semibold uppercase tracking-[0.16em] sm:px-8 lg:px-12" data-id="element-237" data-mp="22ng7v67gc006">
        <p className="text-steel-light" data-id="element-238" data-mp="2bls17fzpdbwb">
          <span className="sm:hidden" data-id="element-239" data-mp="1ewavj10pzpum">Brighton, MI</span>
          <span className="hidden sm:inline" data-id="element-240" data-mp="1exlwkt2s6ji1">Brighton, MI · Serving Southeast Michigan</span>
        </p>
        <a href={contact.phoneHref} className="inline-flex min-h-[40px] items-center gap-2 text-paper transition-colors duration-150 ease-out hover:text-brand-bright" data-id="element-241" data-mp="1ixw2k5qkp9ww">
          <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5 text-brand-bright" strokeWidth={2.25} data-id="element-242" data-mp="1soqqrfndqjkz" />
          <span data-id="element-243" data-mp="v7s2u9gi9ub6">{contact.phoneDisplay}</span>
        </a>
      </div>
    </div>;
}